import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

interface KpiDriversCardProps {
	tileId: string;
	kpiQuestions: string[];
	points: Array<number | null>;
	kpiDriverUrls: string[];
	onNavigate: (url: string) => void;
}

export default function KpiDriversCard({
	tileId,
	kpiQuestions,
	points,
	kpiDriverUrls,
	onNavigate,
}: KpiDriversCardProps) {
	if (!kpiQuestions.length) {
		return (
			<div className="rounded-xl border border-border/50 bg-muted/10 px-4 py-4 text-sm text-muted-foreground">
				No KPI drivers mapped yet.
			</div>
		);
	}

	return (
		<Card className="bg-card/60">
			<CardHeader className="pb-2">
				<CardTitle className="text-sm">KPI Drivers</CardTitle>
			</CardHeader>
			<CardContent className="pt-0">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead className="text-xs uppercase tracking-[0.08em]">
								KPI Driver
							</TableHead>
							<TableHead className="text-xs uppercase tracking-[0.08em] text-right">
								Score
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{kpiQuestions.map((q, idx) => {
							const driverUrl = kpiDriverUrls[idx] || "";

							return (
								<TableRow
									key={`${tileId}:${idx}`}
									className="group hover:bg-muted/40"
								>
									<TableCell className="whitespace-normal align-top pr-6">
										{driverUrl ? (
											<button
												type="button"
												className="w-full text-left text-sm font-semibold leading-snug text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 rounded-sm group-hover:underline"
												onClick={() => onNavigate(driverUrl)}
												aria-label={`Navigate to ${q} KPI driver details. Score: ${points[idx] ?? "Not available"}`}
											>
												{q}
											</button>
										) : (
											<div className="text-sm font-semibold leading-snug text-muted-foreground">
												{q}
											</div>
										)}
									</TableCell>
									<TableCell className="text-right tabular-nums align-top">
										<div className="text-sm font-semibold text-foreground">
											{points[idx] ?? "—"}
										</div>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
}
